import type {ValueFragment} from "app/gql/graphqlSchema";
import {EmptyValue} from "app/employee/controlCard/display/EmptyValue";
import {InvalidValue} from "app/employee/controlCard/display/InvalidValue";
import {RichTextView} from "app/components/admin/rte/RichTextView";

interface Props {
  value: ValueFragment;
}
export const DisplayText = ({value}: Props) => {
  if (value.__typename === "ControlCardTextValue") {
    return <>{value.text}</>;
  }
  if (value.__typename === "ControlCardRichTextValue") {
    return <RichTextView html={value.html} />;
  } else if (value.__typename === "ControlCardEmptyValue") {
    return <EmptyValue />;
  } else {
    return <InvalidValue />;
  }
};
